export const oneStarShop = {
  SG: 'https://onestar.oneclub.vip/',
  MY: 'https://onestar-my.oneclub.vip',
  HK: 'https://onestar-hk.oneclub.vip',
}

export const oneStarFaq = {
  SG: 'https://docs.google.com/document/d/1uy6K_dgvLcjlQv7R2nxUp__QqmQPJ18Jxa6SIopE5bg/edit?tab=t.0',
  MY: 'https://docs.google.com/document/d/1-ptvptXcYmIAPGU28YF6e9Jle8KAhm7YlTmhwN-P1OY/edit?tab=t.0#heading=h.ivq4z9dxm7c3',
  HK: 'https://docs.google.com/document/d/17Byk-dru487VnxAPRPFLZznAaZ3gear2aDg0s502fn8/edit?tab=t.0#heading=h.ivq4z9dxm7c3',
}

/**
 * 支持积分功能的国家地区码
 */
export const oneStarCountryCode = Object.keys(oneStarShop)

export const creditTypes = [
  { value: 'recharge', label: 'creditType.recharge' },
  { value: 'invite_register', label: 'creditType.invite_register' },
  { value: 'credit_redemption', label: 'creditType.credit_redemption' },
  { value: 'other', label: 'common.other' },
]

export const changeTypes = [
  { value: 'ADD', label: 'onestar.changeType.add' },
  { value: 'SUB', label: 'onestar.changeType.sub' },
]
